import { AutogenModelInterfaceCodes, AutogenRowInterfaceCodes } from "./autogen/AutogenModelInterfaceCodes";

export class ModelInterfaceCodes extends AutogenModelInterfaceCodes<RowInterfaceCodes> {
	constructor() {
		super(RowInterfaceCodes);
	}
}

export class RowInterfaceCodes extends AutogenRowInterfaceCodes {
}